import React from 'react';

import {Button, Icon} from '@albert-io/atomic';

import withTracking from 'lib/hocs/withTracking';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import GoogleSignInButton from 'client/components/Google/GoogleSignInButton/GoogleSignInButton.react';
import {
  GOOGLE_CLASSROOM_ASSIGNMENTS_FLAG,
  hasRequestedGoogleClassroomConsent,
  startGoogleClassroomConsent
} from 'client/components/Google/googleClassroomConsent';

const TrackedButton = withTracking(Button, {
  onClick: {event: 'click', content: 'Sign into Google'}
});

/**
 * Google sign-in for the classroom importer. With the assignments flag on, the first sign-in
 * goes through the backend offline-consent flow (which stores the refresh token grade passback
 * needs); afterwards, and with the flag off, it is the standard popup sign-in.
 */
const GoogleClassroomSignInButton = () => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(GOOGLE_CLASSROOM_ASSIGNMENTS_FLAG);

  if (isLoading || (isFeatureEnabled && !hasRequestedGoogleClassroomConsent())) {
    return (
      <TrackedButton
        aria-label='Sign into Google'
        data-testid='google-classroom-consent-sign-in-button'
        disabled={isLoading}
        onClick={() => startGoogleClassroomConsent()}
      >
        <Icon icon={['fab', 'google']} className='mr-x1' />
        Sign into Google
      </TrackedButton>
    );
  }

  return <GoogleSignInButton isButton />;
};

export default GoogleClassroomSignInButton;
